import { render, staticRenderFns } from "./MapChart.vue?vue&type=template&id=56e087d4&scoped=true"
import script from "./MapChart.vue?vue&type=script&lang=js"
export * from "./MapChart.vue?vue&type=script&lang=js"
import style0 from "./MapChart.vue?vue&type=style&index=0&id=56e087d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e087d4",
  null
  
)

export default component.exports